import React, { useContext, Fragment } from "react";
import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { UserContext } from "../../components/context/UserContext";
import { ROLES } from "../../constants/constants";

export const SideNavBar = () => {
  const {
    userDetails: { roleId }
  } = useContext(UserContext);
  return (
    <div className="sidebar-wrapper">
      {[ROLES.ADMIN, ROLES.HROPS, ROLES.RECRUITER].includes(roleId) && (
        <Nav.Item>
          <NavLink to="/CandidateList">Candidates List</NavLink>
        </Nav.Item>
      )}
      {roleId === ROLES.HROPS && (
        <Fragment>
          <Nav.Item>
            <NavLink to="/SEZCandidateList">SEZ Candidates List</NavLink>
          </Nav.Item>
          <Nav.Item>
            <NavLink to="/ExitEmployeeList">Exit Employee List</NavLink>
          </Nav.Item>
        </Fragment>
      )}
      {[ROLES.ADMIN, ROLES.RECRUITER].includes(roleId) && (
        <Nav.Item>
          <NavLink to="/RecruitersList">Recruiters/HR List</NavLink>
        </Nav.Item>
      )}
    </div>
  );
};
export default SideNavBar;
